import React from 'react';
import ReactDOM from 'react-dom';

const InvoicePDFPreviewModal = ({ isOpen, onClose, pdfUrl }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[100140] flex items-center justify-center bg-slate-900/55 p-4 backdrop-blur-sm">
      <div className="flex h-[90vh] w-full max-w-6xl flex-col overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-2xl">
        <div className="relative shrink-0 overflow-hidden rounded-t-2xl border-b border-slate-200/80 bg-gradient-to-br from-white via-slate-50/90 to-cyan-50/25 px-6 py-4">
          <div className="pointer-events-none absolute -right-8 -top-8 h-28 w-28 rounded-full bg-cyan-400/10 blur-2xl" />
          <div className="relative flex items-center justify-between gap-3">
            <div>
              <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">Invoices</p>
              <h3 className="text-lg font-bold text-slate-900 sm:text-xl">Invoice PDF</h3>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => {
                  if (pdfUrl) {
                    const link = document.createElement('a');
                    link.href = pdfUrl;
                    link.download = 'Invoice.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }
                }}
                className="rounded-xl border border-primary/25 bg-primary px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-40"
                disabled={!pdfUrl}
              >
                Download
              </button>
              <button
                type="button"
                onClick={onClose}
                className="rounded-xl p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"
                title="Close"
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="min-h-0 flex-1 p-4">
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              className="w-full h-full border-0 rounded-lg"
              title="Invoice PDF Preview"
            />
          ) : (
            <div className="flex h-full items-center justify-center text-center text-slate-400">
              <p className="text-sm">Generating preview…</p>
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default InvoicePDFPreviewModal; 